export const parseHexString = (str: string): number[] => {
    const result = [];
    while (str.length >= 8) {
        result.push(parseInt(str.substring(0, 8), 16));
        str = str.substring(8, str.length);
    }
    return result;
};

export const createHexString = (arr: number[]): string => {
    let result = '';
    let z;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < arr.length; i++) {
        let str = arr[i].toString(16);
        z = 8 - str.length + 1;
        str = Array(z).join('0') + str;
        result += str;
    }

    return result;
};
